import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";

// POST /api/attendance/punch-in  (multipart/form-data: lat, lng, selfie?)
// Pass projectId to punch in for a specific assigned project regardless of
// which project is globally active.
export const punchInApi = (formData, projectId) =>
  axios.post(`${BASE}/api/attendance/punch-in`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(projectId ? { "x-project-id": projectId } : {}),
    },
  });

// POST /api/attendance/punch-out  (multipart/form-data: lat, lng, selfie?)
export const punchOutApi = (formData, projectId) =>
  axios.post(`${BASE}/api/attendance/punch-out`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(projectId ? { "x-project-id": projectId } : {}),
    },
  });

// POST /api/attendance/workplace-settings  (admin)
// Pass projectId to configure a specific project's geofence regardless of
// which project is globally active.
export const setWorkplaceSettingsApi = (data, projectId) =>
  axios.post(`${BASE}/api/attendance/workplace-settings`, data, {
    headers: projectId ? { "x-project-id": projectId } : {},
  });

// POST /api/attendance/admin/punch-out  { employeeId, date?, time?: "HH:MM" IST, default 18:30 }  (super-admin only)
export const adminPunchOutApi = (data) =>
  axios.post(`${BASE}/api/attendance/admin/punch-out`, data);

// PATCH /api/attendance/admin/punch-in  { employeeId, date: "YYYY-MM-DD", time: "HH:MM" }
export const adminSetPunchInApi = (data) =>
  axios.patch(`${BASE}/api/attendance/admin/punch-in`, data);

// POST /api/attendance/admin/manual
// { employeeId, date: "YYYY-MM-DD", punchIn: "HH:MM", punchOut?: "HH:MM", remarks }
// Super-admin only — records the day by hand (no selfie); remarks are mandatory.
export const adminManualAttendanceApi = (data) =>
  axios.post(`${BASE}/api/attendance/admin/manual`, data);

// POST /api/attendance/auto-mark  { date?, projectId? }  (super-admin only)
export const autoMarkAttendanceApi = (data = {}) =>
  axios.post(`${BASE}/api/attendance/auto-mark`, data);

// GET /api/attendance/selfie-config
export const getSelfieConfigApi = () =>
  axios.get(`${BASE}/api/attendance/selfie-config`);

// POST /api/attendance/selfie-config  { selfieRequired }  (super-admin only)
export const setSelfieConfigApi = (selfieRequired) =>
  axios.post(`${BASE}/api/attendance/selfie-config`, { selfieRequired });

// GET /api/attendance/working-hours?format=register — colour-coded Excel
// attendance register (P / A / L / HF …). Admin only.
export const downloadAttendanceRegister = async ({ from, to, projectId, employeeIds }) => {
  const res = await axios.get(`${BASE}/api/attendance/working-hours`, {
    params: {
      from,
      to,
      format: "register",
      ...(projectId ? { projectId } : {}),
      ...(employeeIds?.length ? { employeeIds: employeeIds.join(",") } : {}),
    },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `attendance-register_${from}_${to}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
